module.exports = __webpack_public_path__ + "static/media/nathania_rismauli.18a7722f.jpg";